// Import external
import { Component, Input, OnInit } from '@angular/core';
import { ExternalLinkService } from '@app/services/external-link.service';

// Import internal
import { Ticket } from '@data/models/ticket.model';

@Component({

    selector: 'syn-ticket-avatar',
    templateUrl: 'ticket-avatar.component.html'
})
export class TicketAvatarComponent implements OnInit {
    @Input() ticket: Ticket;
    @Input() titleInfos = '';
    @Input() showLegend = false;
    @Input() showId = false;
    @Input() caption = '';
    @Input() size = 32;
    @Input() legend = '';
    @Input() backgroundColor: string;
    @Input() iconColor: string;

    public title = '';
    public text = '';

    constructor(private externalLinkService: ExternalLinkService) { }

    public oneViewLink() {
        return this.externalLinkService.getOneViewUrl(this.ticket.id);
    }

    ngOnInit() {
        const name = this.ticket.subject;
        const legend = this.legend || name;
        this.title = this.titleInfos ? legend + ' (' + this.titleInfos + ')' : legend;
        this.text = !this.showLegend ? this.showId ? this.ticket.id : '' : name;
    }
}
